<template>
  <div id="shipments">
   <!--    <b-button @click="deleteShipments">Delete Everything</b-button> -->
   <h4>Shipments Search</h4>
   <br>
   <ul class="tableHead">
    <li>
      <b-row class="text-center">
        <b-col>Scientific Name</b-col>
        <b-col>Shipment Date</b-col>
        <b-col>Arrival Date</b-col>
        <b-col>Supplier</b-col>
        <b-col>Number Received</b-col>

      </b-row>
    </li>
  </ul>
  <ul>
    <li class="formInputs"><b-row class="text-center">
      <b-col><b-form-select @change="onChange" v-model="scientificName"><b-form-select-option v-for="batch of noRepeat(batches).filter(thisUser).slice().reverse()" v-bind:key="batch['.key']" :value="batch.speciesN">{{batch.speciesN}}</b-form-select-option>            
      </b-form-select></b-col>
      <b-col><b-form-input type="date" v-model="shipmentDate" id="shipmentDate" onfocus="this.value=''" @change="onChange"></b-form-input></b-col>
      <b-col><b-form-input type="date" v-model="arrivalDate" id="arrivalDate" onfocus="this.value=''" @change="onChange"></b-form-input></b-col>
      <b-col><b-form-input type="text" v-model="supplier" id="supplier" list="supplierList" onfocus="this.value=''" @change="onChange"></b-form-input></b-col>
      <b-col><b-form-input type="text" v-model="numberReceived" id="numberReceived" onfocus="this.value=''" @change="onChange"></b-form-input></b-col>

    </b-row></li>
  </ul>
  <b-row class="text-center">
    <b-col>
      <b-button @click="decreaseRows()" variant="outline-primary"><b-icon-arrow-left-short></b-icon-arrow-left-short></b-button>
      {{searchShipment.filter(thisUser).length==0?0:numRows+1}} to {{(numRows+7)>searchShipment.filter(thisUser).length? searchShipment.filter(thisUser).length:numRows+7}} of {{searchShipment.filter(thisUser).length}}
      <b-button @click="increaseRows()" variant="outline-primary"><b-icon-arrow-right-short></b-icon-arrow-right-short></b-button>
    </b-col>
  </b-row>
  <br>
  <div id="shipmentsTable" class="noselect">
    <div>
      <ul class="tableHead">
        <li>
          <b-row class="text-center">
            <b-col cols="1">ID</b-col>
            <b-col>Shipment Date</b-col>
            <b-col>Arrival Date</b-col>
            <b-col>Supplier</b-col>
            <b-col>Number Received</b-col>
            <b-col>Accounted For</b-col>
          </b-row>
        </li>
      </ul>
      <datalist id="supplierList">
        <option>LPS</option>
        <option>TEH</option>
        <option>GC</option>
        <option>EBN</option>
        <option>SUA</option>
        <option>CRES</option>
      </datalist>
    </div>
    <div>

      <ul class="tableBody">
        <li v-for="shipment of searchShipment.filter(thisUser).slice().reverse().slice(numRows, numRows+7)" v-bind:key="shipment['.key']" class="tableElement" >
          <b-row class="text-center">
            <b-col cols="1">{{shipment.id}}</b-col>
            <b-col @click="toShipment(shipment['.key'])">{{getFormattedDate(shipment.shipmentDate)}}</b-col>
            <b-col @click="toShipment(shipment['.key'])">{{getFormattedDate(shipment.arrivalDate)}}</b-col>
            <b-col @click="toShipment(shipment['.key'])">{{shipment.supplier}}</b-col>
            <b-col @click="toShipment(shipment['.key'])">{{shipment.numberReceived}}</b-col>      
            <b-col @click="toShipment(shipment['.key'])">{{shipment.accountedFor}}</b-col>      
          </b-row>            

        </li>
      </ul>
    </div></div>

    <div id="snackbar">{{toastMessage}}</div>
  </div>
</template>

<style>
#shipments {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  padding: 10px 50px 50px 50px;
}

.tableHead{
  background-color: #343a40;
  padding: 10px 10px 10px 10px;
  color: white;
  display: block;
}

.tableBody {
  display:block;

}


.tableElement{
  padding: 10px 10px 10px 10px;
  z-index: -1;
  color:black;
  cursor: pointer;
  border-top: dotted 1px;
}

.floatAbove{
  z-index: 2;
}

.formInputs{
  padding: 10px 10px 10px 10px;
}

.tableElement:hover{
  background-color: grey;
  padding: 10px 10px 10px 10px; 
  color:white;

}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 10px 10px;
}

a {
  color: #42b983;
}

#snackbar {
  visibility: hidden; /* Hidden by default. Visible on click */
  min-width: 250px; /* Set a default minimum width */
  margin-left: -125px; /* Divide value of min-width by 2 */
  background-color: #333; /* Black background color */
  color: #fff; /* White text color */
  text-align: center; /* Centered text */
  border-radius: 2px; /* Rounded borders */
  padding: 16px; /* Padding */
  position: fixed; /* Sit on top of the screen */
  z-index: 1; /* Add a z-index if needed */
  left: 45%; /* Center the snackbar */
  bottom: 30px; /* 30px from the bottom */
}


#snackbar.show {
  visibility: visible; 
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}

/* Animations to fade the snackbar in and out */
@-webkit-keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@keyframes fadein {
  from {bottom: 0; opacity: 0;}
  to {bottom: 30px; opacity: 1;}
}

@-webkit-keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}

@keyframes fadeout {
  from {bottom: 30px; opacity: 1;}
  to {bottom: 0; opacity: 0;}
}

</style>

<script>
import { shipmentsRef } from '../firebase'
import { butterflyRef } from '../firebase'
import { batchRef } from '../firebase'
export default {
  name: 'shipments',
  data () {
    return {
      shipments: [],
      batches: [],
      shipmentDate: '',
      arrivalDate: '',
      supplier: '',
      species: '',
      commonName: '',
      numberReceived: '',
      scientificName: '',
      butterflies: [],
      toastMessage: '',
      numRows: 0,
      numElements: 10,
      searchShipment: []
    }
  },
  firebase: {
    shipments: shipmentsRef,
    butterflies: butterflyRef,
    batches: batchRef
  },
  methods: {
    add() {
      if(this.shipmentDate === '' || this.arrivalDate === '' || this.supplier === '' || this.numberReceived === ''){
        this.showSnackBar('Please fill out all fields');
        return;
      }
      if(isNaN(this.numberReceived)){
        this.showSnackBar('Number received should be a number');
        return;
      }

      if(this.numberReceived<0){
        this.showSnackBar('Number received cannot be negative');
        return;
      }

      if(this.shipments.length>0){
        shipmentsRef.push({id: this.shipments[this.shipments.length-1].id+1, shipmentDate: this.shipmentDate, arrivalDate: this.arrivalDate, supplier: this.supplier, numberReceived: this.numberReceived,
          edit:false, accountedFor: 0});
      }else {
        shipmentsRef.push({id: 1, shipmentDate: this.shipmentDate, arrivalDate: this.arrivalDate, supplier: this.supplier, numberReceived: this.numberReceived,
          edit:false, accountedFor: 0});
      }
      this.showSnackBar('Shipment Added');
    },
    remove(key) {
      shipmentsRef.child(key).remove();
      for(let i =0; i<this.batches.length; i++){
        if(this.batches[i].id==key){
          batchRef.child(this.batches[i]['.key']).remove();
          i--;
        }
      }
      this.showSnackBar('Shipment Removed');
    },
    edit(key){
      shipmentsRef.child(key).update({edit: true});
    },
    cancel(key){
      shipmentsRef.child(key).update({edit: false});
    },
    save(shipment){
      if(shipment.shipmentDate === '' || shipment.arrivalDate === '' || shipment.supplier === '' || shipment.numberReceived === ''){
        this.showSnackBar('Please fill out all fields');
        return;
      }
      if(isNaN(shipment.numberReceived)){
        this.showSnackBar('Number Received should be a number');
        return;
      }

      if(shipment.numberReceived<0){
        this.showSnackBar('Number received cannot be negative');
        return;
      }

      const key = shipment['.key'];
      shipmentsRef.child(key).update({shipmentDate: shipment.shipmentDate, arrivalDate: shipment.arrivalDate, supplier: shipment.supplier,numberReceived: shipment.numberReceived, edit:false});
      this.showSnackBar('Shipment Updated');
    },
    validation() {

    },
    showSnackBar(message){
      this.toastMessage = message;
      var x = document.getElementById("snackbar");
      x.className = "show";
      setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
    },
    toShipment(key){
      this.$router.push({name:'Shipment', params: {id: key}})
    },
    getFormattedDate(dateParam) {

      var date = new Date(dateParam);

      var month = date.getMonth()+1;

      var day = date.getDate()+1;

      var year = date.getFullYear();

      return month + "/" + day + "/" + year;

    },
    increaseRows(){
      if((this.searchShipment.filter(this.thisUser).length-this.numRows-7)>0){
        this.numRows+=7
      }
    },
    decreaseRows(){
      if((this.numRows>=7)){
        this.numRows-=7
      }
    },
    noRepeat(batches){
      var nRB = [];
      for(let i=0; i<batches.length; i++){
        if(nRB.length==0){
          nRB.push(batches[i]);
        }else{
          var contains = false;
          for(let j=0; j<nRB.length; j++){
            if(nRB[j].speciesN == batches[i].speciesN){
              contains = true;
            }
          }
          if(!contains){
            nRB.push(batches[i]);
          }
        }
      }
      return nRB;
    },
    noRepeatCommon(batches){
      var nRB = [];
      for(let i=0; i<batches.length; i++){
        if(nRB.length==0){
          nRB.push(batches[i]);
        }else{
          var contains = false;
          for(let j=0; j<nRB.length; j++){
            if(nRB[j].commonName == batches[i].commonName){
              contains = true;
            }
          }
          if(!contains){
            nRB.push(batches[i]);
          }
        }
      }
      return nRB;
    },
    onChange(){
      this.numRows = 0;
      this.searchShipment = [];
      for(let i=0; i<this.shipments.length; i++){
        for(let j=0; j<this.batches.length; j++){
          if(this.batches[j].id == this.shipments[i]['.key']){
            if(this.batches[j].speciesN == this.scientificName || this.scientificName === ''){
              var shipmentDate = new Date(this.shipments[i].shipmentDate);
              var arrivalDate = new Date(this.shipments[i].arrivalDate);
              var thisShipmentDate = new Date(this.shipmentDate);
              var thisArrivalDate = new Date(this.arrivalDate);
              if(shipmentDate.getTime() == thisShipmentDate.getTime() || this.shipmentDate === ''){
                if(arrivalDate.getTime() == thisArrivalDate.getTime() || this.arrivalDate === ''){
                  if(this.shipments[i].supplier == this.supplier || this.supplier === ''){
                    if(this.numberReceived == this.shipments[i].numberReceived || this.numberReceived === ''){
                      this.searchShipment.push(this.shipments[i]);
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    getUser(){
      return this.$parent.activeUser?this.$parent.activeUser.name:'';
    },
    thisUser(shipment){
      return (shipment.user == this.getUser() || this.getUser() == 'Reiman Gardens')?shipment:null
    }
      // deleteShipments(){
      //   for(let i=0; i<this.shipments.length; i++){
      //     shipmentsRef.child(this.shipments[i]['.key']).remove();
      //   }

      //   for(let j=0; j<this.batches.length; j++){
      //     batchRef.child(this.batches[j]['.key']).remove();
      //   }
      // }
    }
  }
  </script>

